import React, {useEffect, useState} from 'react';
import './Attachments.css';

        const applicantsData = [
            {
                id: 1,
                name: 'Jane Doe',
                photoUrl: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?q=80&w=400&auto=format&fit=crop',
                applicationDate: '2025-08-28',
                status: 'Pending',
                documents: [
                    { name: 'Resume_Jane_Doe.pdf', type: 'pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
                    { name: 'Cover_Letter.docx', type: 'word', url: '#' },
                    { name: 'Portfolio_Preview.jpg', type: 'image', url: 'https://images.unsplash.com/photo-1587620962725-abab7fe55159?q=80&w=800&auto=format&fit=crop' },
                ],
            },
            {
                id: 2,
                name: 'John Smith',
                photoUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&auto=format&fit=crop',
                applicationDate: '2025-08-27',
                status: 'Approved',
                documents: [
                    { name: 'CV_John_Smith.pdf', type: 'pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
                    { name: 'ID_Scan.jpg', type: 'image', url: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=800&auto=format&fit=crop' },
                ],
            },
            {
                id: 3,
                name: 'Maria Garcia',
                photoUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=400&auto=format&fit=crop',
                applicationDate: '2025-08-25',
                status: 'Rejected',
                documents: [
                    { name: 'Resume_Maria_Garcia.pdf', type: 'pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
                ],
            },
             {
                id: 4,
                name: 'Ken Alvarez',
                photoUrl: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=400&auto=format&fit=crop',
                applicationDate: '2025-08-22',
                status: 'Pending',
                documents: [
                    { name: 'Resume_Alvarez.pdf', type: 'pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' },
                    { name: 'Transcript.docx', type: 'word', url: '#' },
                ],
            },
        ];
        
        const getFileIcon = (type) => {
            switch(type) {
                case 'pdf': return 'bi bi-file-earmark-pdf-fill';
                case 'word': return 'bi bi-file-earmark-word-fill';
                case 'image': return 'bi bi-file-earmark-image-fill';
                default: return 'bi bi-file-earmark-fill';
            }
        };

        const getStatusBadge = (status) => {
            switch(status) {
                case 'Pending': return 'bg-warning text-dark';
                case 'Approved': return 'bg-success';
                case 'Rejected': return 'bg-danger';
                default: return 'bg-secondary';
            }
        }

        const DocumentViewerModal = ({ doc, show, handleClose }) => {
            if (!show || !doc) return null;
            
            // Note: For DOCX files, a real-world app would need a server-side conversion 
            // to PDF or an image for browser preview, or use a library like Mammoth.js.
            // Here, we'll just show a message.
            const isViewable = doc.type === 'pdf' || doc.type === 'image';
            const isDocx = doc.type === 'word';

            return (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{doc.name}</h5>
                                <button type="button" className="btn-close" onClick={handleClose}></button>
                            </div>
                            <div className="modal-body">
                                {isViewable && doc.type === 'image' && (
                                    <img src={doc.url} alt={doc.name} className="image-preview" />
                                )}
                                {isViewable && doc.type === 'pdf' && (
                                     <iframe src={doc.url} title={doc.name} className="iframe-preview"></iframe>
                                )}
                                {isDocx && (
                                     <div className="text-center p-5">
                                        <i className="bi bi-file-earmark-word-fill" style={{fontSize: '4rem', color: '#0d6efd'}}></i>
                                        <p className="mt-3">.docx files cannot be previewed directly.</p>
                                        <p>Please download the file to view its contents.</p>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                                <a href={doc.url} target="_blank" rel="noopener noreferrer" className="btn btn-primary" download={doc.name}>
                                    <i className="bi bi-download me-2"></i>Download
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            );
        };

        const ApplicantCard = ({ application, applicant, handleStatusChange, onViewDocument, remarks, setRemarks, applicationFormType }) => {
            return (
                <div className="col">
                    <div className="card h-100 applicant-card">
                        <div className="card-body">
                            {/*<div className="d-flex align-items-center mb-3">
                                <img src={applicant.photoUrl} alt={applicant.name} className="applicant-photo me-3" />
                                <div>
                                    <h5 className="card-title mb-0">{applicant.name}</h5>
                                    <small className="text-muted">Applied on: {applicant.applicationDate}</small>
                                </div>
                            </div>*/}
                            {/*<span className={`badge ${getStatusBadge(application.applicationStatus)} status-badge mb-3`}>{application.applicationStatus}</span>*/}
                            
                            <h6 className="text-muted small text-uppercase">Documents</h6>
                            <div className="d-flex flex-column gap-2">
                                {applicant.map((doc, index) => (
                                    <>
                                    <a key={index} className="document-link" onClick={() => onViewDocument(doc)}>
                                        <i className={getFileIcon(doc.type)}></i>
                                        <span>{doc.name}</span>
                                    </a>
                                    </>
                                ))}
                                    {/*<a key={index} className="document-link" onClick={() => onViewDocument(applicant)}>
                                        <i className={getFileIcon(doc.type)}></i>
                                        <span>{doc.name}</span>
                                    </a>
                                    <a key={index} className="document-link" onClick={() => onViewDocument(applicant)}>
                                        <i className={getFileIcon(doc.type)}></i>
                                        <span>{doc.name}</span>
                                    </a>
                                    <a key={index} className="document-link" onClick={() => onViewDocument(applicant)}>
                                        <i className={getFileIcon(doc.type)}></i>
                                        <span>{doc.name}</span>
                                    </a>
                                    <a key={index} className="document-link" onClick={() => onViewDocument(doc)}>
                                        <i className={getFileIcon(doc.type)}></i>
                                        <span>{doc.name}</span>
                                    </a>*/}

                            </div>
                        </div>
                       
                    </div>
                </div>
            )
        };


export default function ShowAttachments(props) {
    const {application, remarks, setRemarks , handleApplicationStatusChange, applicationFormType}=props;
    const [applicants, setApplicants] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Define a base URL for the documents. This should be the path where the files are hosted.
    const BASE_URL = `https://s3.ap-south-1.amazonaws.com/images.mduschooled.in/staff/${application.appliedSchoolID}/${application.applicationID}/profile/`;

        useEffect(()=>{
            // Perform the conversion
            const convertedDocuments = convertToDocumentsArray(application);
            // Log the result to the console
           // console.log(convertedDocuments);
            setApplicants(convertedDocuments);
        },[]);


        // Define a function to determine the file type from its extension
        function getFileType(filename) {
        const extension = filename.split(".").pop().toLowerCase();
        if (["jpg", "jpeg", "png", "gif", "svg"].includes(extension)) {
            return "image";
        }
        if (["pdf"].includes(extension)) {
            return "pdf";
        }
        if (["doc", "docx"].includes(extension)) {
            return "word";
        }
        return "other";
        }

        // Function to convert the item object to the documents array
        /*function convertToDocumentsArray(sourceObject) {
        const documents = [];

        for (const key in sourceObject) {
            if (Object.hasOwnProperty.call(sourceObject, key)) {
            const value = sourceObject[key];

            // Check if the value is a string (a file path) and not a boolean like 'terms'
            if (typeof value === "string" && value.includes(".")) {
                const name = `${key.replace(/([a-z])([A-Z])/g, "$1 $2")
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}`.replace(/marksheet/i, "Marksheet")
                .replace(/certificate/i, "Certificate");

                const type = getFileType(value);
                const url = `${BASE_URL}${value}`;

                documents.push({
                name: `${name}.${value.split(".").pop()}`,
                type: type,
                url: url,
                });
            }
            }
        }

        return documents;
        }*/

        // Function to convert the item object to the documents array using a whitelist of keys
        function convertToDocumentsArray(sourceObject) {
        const documents = [];

        // Define the specific keys to be converted
        const keysToConvert = [
            "tenthMarksheet",
            "tetCertificate",
            "tweelthMarksheet",
            "ugCertificate",
            "ugMarksheet",
            "pgCertificate",
            "paymentReceipt"
        ];

        keysToConvert.forEach((key) => {
            // Check if the key exists and has a string value in the source object
            if (sourceObject[key] && typeof sourceObject[key] === "string") {
            const value = sourceObject[key];
            const name = `${key
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}`;
            const type = getFileType(value);
            const url = `${BASE_URL}${value}`;

            documents.push({
                name: `${name}.${value.split(".").pop()}`,
                type: type,
                url: url,
            });
            }
        });

        return documents;
        }

            const handleStatusChange = (event, id, newStatus) => {
                event.preventDefault();
                handleApplicationStatusChange(event, id,newStatus);
                handleCloseModal();
            };

            const handleViewDocument = (doc) => {
                setSelectedDoc(doc);
                setIsModalOpen(true);
            };

            const handleCloseModal = () => {
                setIsModalOpen(false);
                setSelectedDoc(null);
            };



  return (
    <div>
        <React.Fragment>
                    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#">
                                <i className="bi bi-person-vcard-fill me-2"></i>
                                Attachments
                            </a>
                        </div>
                    </nav>

                    <main className="container my-5 flex-grow-1">
                       {/*} <div className="d-flex justify-content-between align-items-center mb-4">
                            <h1 className="h2">Applicant Review</h1>
                            <span className="badge bg-primary rounded-pill">{applicants.length} Total Applicants</span>
                        </div>*/}
                        
                        <div className="row">
                                <ApplicantCard 
                                    key={application.applicationID} 
                                    applicant={applicants} 
                                    application={application}
                                    handleStatusChange={handleStatusChange}
                                    onViewDocument={handleViewDocument}
                                    remarks={remarks}
                                    setRemarks={setRemarks}
                                    applicationFormType={applicationFormType}
                                />

                            {/*applicants.map(applicant => (
                                <ApplicantCard 
                                    key={applicant.id} 
                                    applicant={applicant} 
                                    onStatusChange={handleStatusChange}
                                    onViewDocument={handleViewDocument}
                                />
                            ))*/}
                        </div>
                    </main>

                    {/*<footer className="bg-dark text-white text-center py-3 mt-auto">
                        <div className="container">
                            <p className="mb-0">&copy; 2025 Job Application Portal</p>
                        </div>
                    </footer>*/}
                    
                    <DocumentViewerModal doc={selectedDoc} show={isModalOpen} handleClose={handleCloseModal} />
                </React.Fragment>
    </div>
  )
}
